import { Dialog, DialogContent, DialogHeader, DialogTitle } from '../ui/dialog';
import { CheckCircle2, XCircle, Loader2 } from 'lucide-react';

function gradeColor(note) {
  if (note >= 16) return 'text-emerald-400';
  if (note >= 12) return 'text-blue-400';
  if (note >= 10) return 'text-amber-400';
  return 'text-red-400';
}

function AnswerIcon({ correct, points }) {
  if (correct) return <CheckCircle2 className="w-5 h-5 text-emerald-400 shrink-0" />;
  if (points > 0) return <CheckCircle2 className="w-5 h-5 text-amber-400 shrink-0" />;
  return <XCircle className="w-5 h-5 text-red-400 shrink-0" />;
}

function answerBg(d) {
  if (d.correct) return 'bg-emerald-400/5 border border-emerald-400/20';
  if (d.points > 0) return 'bg-amber-400/5 border border-amber-400/20';
  return 'bg-red-400/5 border border-red-400/20';
}

function answerColor(d) {
  if (d.correct) return 'text-emerald-400';
  if (d.points > 0) return 'text-amber-400';
  return 'text-red-400';
}

export function ResultDetailModal({ open, onOpenChange, loading, result }) {
  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent className="bg-card border-border max-w-lg max-h-[80vh] overflow-y-auto">
        <DialogHeader>
          <DialogTitle className="flex items-center justify-between">
            <span>Détail du résultat</span>
            {result && (
              <span className={`text-2xl font-black ${gradeColor(result.note)}`}>
                {result.note}/{result.bareme}
              </span>
            )}
          </DialogTitle>
        </DialogHeader>
        {loading ? (
          <div className="flex items-center justify-center py-8">
            <Loader2 className="w-6 h-6 animate-spin text-primary" />
          </div>
        ) : result ? (
          <div className="space-y-4">
            <div className="bg-secondary/50 rounded-lg p-4 space-y-1">
              <p className="font-bold text-lg">{result.student_name}</p>
              <p className="text-sm text-muted-foreground">
                Classe: {result.classe} &middot; ID: <span className="font-mono">{result.exam_id}</span>
              </p>
              <p className="text-sm text-muted-foreground">
                Bonnes réponses: {result.total_correct}/{result.total_questions}
              </p>
            </div>

            <div className="space-y-2">
              <p className="text-xs text-muted-foreground uppercase tracking-wider font-bold">Réponses question par question</p>
              {result.details?.map((d, i) => (
                <div key={d.question_id || `detail-${i}`} className={`flex items-center gap-3 p-3 rounded-lg ${answerBg(d)}`} data-testid={`detail-answer-${i}`}>
                  <AnswerIcon correct={d.correct} points={d.points} />
                  <div className="flex-1">
                    <span className="text-sm font-medium">{d.question}</span>
                    {d.type === 'multiple' && <span className="ml-2 text-xs text-violet-400 bg-violet-400/10 px-1.5 py-0.5 rounded">Multi</span>}
                  </div>
                  <div className="text-right text-sm">
                    <div>
                      Réponse: <span className={`font-bold ${answerColor(d)}`}>{d.reponse_eleve || '\u2014'}</span>
                    </div>
                    {!d.correct && (
                      <div className="text-xs text-muted-foreground">
                        Attendu: <span className="text-emerald-400 font-bold">{d.bonne_reponse}</span>
                      </div>
                    )}
                  </div>
                  <span className={`text-sm font-black min-w-[40px] text-right ${answerColor(d)}`}>
                    {d.points > 0 ? `+${d.points}` : '0'}
                  </span>
                </div>
              ))}
            </div>
          </div>
        ) : null}
      </DialogContent>
    </Dialog>
  );
}
